import Http from '@/Http';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
import { Enterprise } from '@/types/work/enterprise';
import { Provider } from '@/types/work/invoice';

export const PROVIDERS_REQUEST = 'work/enterprises/providers/request';
export const STORE_REQUEST = 'work/enterprises/providers/storeRequest';
export const GET_PROVIDERS = 'work/enterprises/providers/getProviders';

const state = {
  status: null,
  providers: [],
  provider: {}
};

const getters = {
  getProviders: (state:any):Array<Provider> => state.providers
};

const actions = {
  request: ({ commit, dispatch }:any, enterprise:number, filter:any = {}) => {
    filter = {
      'filters[order_by]': 'title',
      ...filter
    };
    commit('request');
    (new Http()).request({ url: `enterprise/${enterprise}/providers`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  storeRequest: ({ commit, rootGetters }:any, data:Provider) => {
    let validData = {
      title: data.title
    };
    commit('request');
    return new Promise((resolve, reject) => {
      let enterprise: Enterprise = rootGetters[GET_ENTERPRISE];
      let url = data.id
        ? `enterprise/${enterprise.id}/providers/${data.id}`
        : `enterprise/${enterprise.id}/providers`;
      (new Http()).request({ url: url, data: validData, method: 'POST' })
        .then((resp:any) => {
          if (resp.data.data) {
            commit('successStore', { resp: data, update: !!data.id });
          }
          resolve(resp.data.data);
        })
        .catch((e:any) => {
          commit('error');
          reject(e);
        });
    });
  }
};

const mutations = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state:any, resp:Array<Provider>) => {
    state.status = true;
    state.providers = resp;
  },
  successStore: (state:any, { resp, update }:any) => {
    state.status = true;
    if (update) {
      let found = false;
      for (let i = 0; i < state.providers.length; i++) {
        if (state.providers[i].id === resp.id) {
          state.providers[i] = resp;
          found = true;
          break;
        }
      }
      if (!found) {
        state.providers[state.providers.length] = resp;
      }
    } else {
      state.providers[state.providers.length] = resp;
    }
  },
  error: (state:any) => {
    state.status = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
